import { Map as ImmutableMap, List } from 'immutable';
import { FETCH_USERS_STARTED, FETCH_USERS_SUCCEEDED } from '../actions/ActionTypes';
import { STARTED, UNINITIALIZED, SUCCEEDED } from '../constants/RequestStatusTypes';
const initialState = ImmutableMap({
  status: UNINITIALIZED,
  users: List()
});
export default function users(state = initialState, action) {
  switch (action.type) {
    case FETCH_USERS_STARTED:
      return state.merge({
        status: STARTED
      });
    case FETCH_USERS_SUCCEEDED:
      {
        const {
          payload
        } = action;
        return state.merge({
          status: SUCCEEDED,
          users: payload
        });
      }
    default:
      return state;
  }
}